import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fd990dba"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd990dba')) {
      api.createRecord('fd990dba', component.options)
    } else {
      api.reload('fd990dba', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=fd990dba", function () {
      api.rerender('fd990dba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vip/coupon/wushareCouponClassNotice/index.vue"
export default component.exports